import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import pl from "./translations/pl.json";
import en from "./translations/en.json";

i18n.use(LanguageDetector).init({
    resources: {en, pl},
    fallbackLng: "en",
    debug: false,
    interpolation: {escapeValue: false},

    ns: ["applicationRootPage", "testStartPage", "codeAssignmentPage", "testSummaryPage", "privacyPolicy", "testNotFoundPage"],
    defaultNS: "translations",

    react: {
        wait: true
    }
}).then();

export default i18n;